<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Pill Styling</label>
          <v-row class="mb-3">
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="fields.pillStyles.borderRadius"
                label="Border Radius (number only)"
                type="number"
                hide-details
              />
            </v-col>
          </v-row>
          <v-row class="mb-3">
            <v-col cols="12" md="6">
              <ColorPicker
                :value="fields.pillStyles.borderBackground"
                label="Border Color"
                name="borderBackground"
                default-color="#ffffff33"
                @input="fields.pillStyles.borderBackground = $event"
              />
            </v-col>
            <v-col cols="12" md="6">
              <ColorPicker
                :value="fields.pillStyles.textColorPill"
                label="Text Color"
                name="textColorPill"
                default-color="#ffffff"
                @input="fields.pillStyles.textColorPill = $event"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <ColorPicker
                :value="fields.pillStyles.backgroundColorPill"
                label="Background Color"
                name="backgroundColorPill"
                default-color="#ffffff1a"
                @input="fields.pillStyles.backgroundColorPill = $event"
              />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Pills</label>
            <input type="checkbox" v-model="fields.showPills" />
          </div>
          <div class="d-flex justify-space-between align-center mb-2">
            <span class="caption">Manage pill items</span>
            <v-btn small text color="primary" @click="handleAddPill">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Pill</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(pill, index) in fields.pills" :key="`cedrow-pill-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Pill {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemovePill(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="label-input mb-2 d-block">Icon</label>
                    <UploadImage
                      @callback="obj => handleUploadPillIcon(obj, index)"
                      :image="{ imageSrc: pill.icon || '' }"
                      :height="`80`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemovePillIcon(index)"
                    />
                  </div>
                  <div class="mt-3">
                    <label class="mb-2 d-block">Content</label>
                    <v-text-field v-model="pill.content" label="Pill text content" outlined dense hide-details />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Section Content</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.sectionContent" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" @update:button="fields.button = $event" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';
import ColorPicker from './common/color-picker.vue';
import ButtonPrimary from './common/button-primary.vue';

const defaultIcon = 'https://cdn.skyfastimg.com/images/2026/06/15/image-6a2fb04bed73b6428256aeef.png';

export default {
  name: 'cedrow-section-freetype-content-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
    ColorPicker,
    ButtonPrimary,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Cedrow Freetype Content',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#ffffff',
          textColor: '#000000',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        showPills: true,
        pills: [],
        sectionContent: '<p>Add your content here</p>',
        pillStyles: {
          borderRadius: 10,
          borderBackground: '#ffffff33',
          textColorPill: '#ffffff',
          backgroundColorPill: '#ffffff1a',
        },
        button: {},
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        pills: Array.isArray(extract.pills) ? extract.pills : this.fields.pills,
        sectionContent: extract.sectionContent || this.fields.sectionContent,
        pillStyles: { ...this.fields.pillStyles, ...(extract.pillStyles || {}) },
        button: extract.button || this.fields.button,
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCedrowFreetypeContent(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddPill() {
      this.fields.pills.push({
        icon: defaultIcon,
        content: 'New pill text',
      });
    },
    handleRemovePill(index) {
      this.fields.pills.splice(index, 1);
    },
    handleUploadPillIcon(obj, index) {
      if (!this.fields.pills[index]) return;
      this.$set(this.fields.pills[index], 'icon', obj.imageSrc || '');
    },
    handleRemovePillIcon(index) {
      if (!this.fields.pills[index]) return;
      this.$set(this.fields.pills[index], 'icon', '');
    },
  },
};
</script>
